<template>
    <div class="container">
        <div
            v-for="(marker, index) in markers"
            :key="index"
            class="row pt-2 pb-2 selection-row"
            @click.stop="$emit('mapItemSelected', marker)"
        >
            <!-- Icon container -->
            <div class="col-1 flex justify-center items-center flex-shrink-0">
                <template v-if="marker.type === TRAFFIC_SIGN || marker.type === EXTERNAL_TRAFFIC_SIGNS">
                    <div style="position: relative; display: inline-block; margin: 0; padding: 0; width: 1.8em; height: 1.8em">
                        <img
                            class="option__image"
                            :src="getRoadSignImage(marker.data.sign)"
                            alt=""
                            style="width: 100%; height: 100%; object-fit: contain"
                        />
                        <span v-if="marker.data.sign === 'C32'" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #000000; font-size: .8em; font-weight: bold;  text-align: center;">60</span>
                    </div>
                </template>

                <template v-else-if="marker.data?.external_system_id">
                    <img
                        :src="getEquipmentIcon(marker.type)"
                        class="w-5 h-5"
                        style="height: 1.6em; width: 1.6em; object-fit: contain"
                        :style="marker.type === EXTERNAL_STAIRS ? 'filter: invert(100%)' : ''"
                        alt=""
                    />
                </template>

                <template v-else-if="marker.type === SPREADER_DATA">
                    <!-- Optional icon/image here -->
                </template>

                <template v-else-if="marker.type === HARJA_MESSAGES">
                    <div v-html="markerStore.getHarjaNotificationMarkerIcon()" style="margin-top: .5em" class="inline-block" />
                </template>

                <template v-else>
                    <div
                        v-html="getMarkerDiv(markerStore, marker.type)"
                        style="margin-top: .5em"
                        class="inline-block"
                    />
                </template>
            </div>

            <!-- Text -->
            <div class="col-11 pl-3 text-gray-800 d-flex align-items-center">
                <template v-if="marker.type === TRAFFIC_SIGN || marker.type === EXTERNAL_TRAFFIC_SIGNS">
                    {{ getEquipmentTypeName(marker.type) }} {{ marker.data.sign }}
                </template>
                <template v-else-if="marker.data?.external_system_id">
                    {{ getEquipmentTypeName(marker.type) }}
                </template>
                <template v-else-if="marker.type === SPREADER_DATA">
                    {{ getEquipmentTypeName(marker.type) }}
                </template>
                <template v-else-if="marker.type === HARJA_MESSAGES">
                    {{ marker.data?.ilmoitus?.ilmoitusid || 'Harja ilmoitus' }}
                </template>
                <template v-else-if="marker.type === SKI_TRACK">
                    {{ marker.data.routeName }}
                </template>
                <template v-else>
                    {{ marker.data?.name || getMarkerTypeName(marker.type) }}
                </template>
            </div>
        </div>

    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";

const imageModules = import.meta.glob('@/assets/roadsign/**/*.{svg,png,jpg}', {eager: true});
export default {
    name: "MapItemSelector",
    mixins: [mapHelper, conversionModelHelper, roadSignHelper],
    props: {
        markerStore: {
            type: Object,
            required: true
        },
        markers: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function(){
        return{
            options: [],
        }
    },
    mounted() {
        this.options = [
            { value: this.OBSERVATION, text: this.$t('menu.observations') },
            { value: this.WORK_ASSIGNMENT, text: this.$t('map_tooltips.work_assignments') },
            { value: this.TRAFFIC_SIGN, text: this.$t('map_tooltips.traffic_signs') },
            { value: this.STREET_LIGHT, text: this.$t('menu.street_lights') },
            { value: this.POWER_CENTER, text: this.$t('power_stations.station') },
            { value: this.CABLE, text: this.$t('cables.cable') },
            { value: this.SEWERS, text: this.$t('storm_sewers.sewers') },
            { value: this.DRAINS, text: this.$t('storm_sewers.drains') },
        ]
    },
    methods: {
        getRoadSignImage(signName) {
            try {
                const iconName = this.getSignIcon(signName);
                const imagePath = `/src/assets/roadsign/${iconName}`;
                const imageModule = imageModules[imagePath];

                if (imageModule) {
                    return imageModule.default || imageModule;
                } else {
                    return ""; // Fallback for missing images
                }
            } catch (error) {
                console.warn(`Road sign image not found: ${signName}`, error);
                return "";
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.selection-row {
    border-bottom: 1px solid #d9d9d9;
    cursor: pointer;
    padding: .2em;
}

.selection-row:hover {
    background: #dff1bd;
}

.image-container {
    position: relative;
    display: inline-block;
    margin: 0;
    padding: .1em;
    width: 2em; /* Set width for the container (adjust as needed) */
    height: 2em; /* Set height for the container (adjust as needed) */
}

.image {
    margin-left: .2em;
    width: 90%;
    height: auto;
    object-fit: contain; /* Ensures the image covers the container without distortion */
}

.overlay-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000000;
    font-size: .8em;
    padding-left: 1px;
    font-weight: bold;
    text-align: center;
}

</style>
